function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

window.debounce = debounce;

function toFixed(num, fixed) {
  var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  if (num === undefined || isNaN(num)) {
    return NaN;
  }
  return num.toString().match(re)[0];
}

window.toFixed = toFixed;

Number.prototype.toLocaleFixed = function(n) {
    return this.toLocaleString(undefined, {
      minimumFractionDigits: n,
      maximumFractionDigits: n
    });
};

function floatFromInput(selector) {
  // Get the value
  let value = $(selector).val();
  // Transform comma to dot
  value = value.replace(',', '.');
  // Remove any withspace
  value = value.replace(' ', '');
  // Parse the value to a float
  value = parseFloat(value);
  // Return the value
  return value;
}

window.floatFromInput = floatFromInput;


$('.voirPaiements').on('click', function(){
    id = $(this).data("id");

    $('.collapseOf'+id).collapse('toggle');
});


$('#btn-prolong').on('click', function(){
    $('#prolong_contrat_container').toggleClass('invisible');
})

$('.acquirerResponseTooltip').tooltip();
$('.responseTooltip').tooltip();


// Encaissement
$('#selectEncaissement').change(function () {
    // Si le paiement est de type espèce
    if ($(this).val() == 4) {
        $('#referenceEncaissement').prop('disabled', true);
    } else {
        $('#referenceEncaissement').prop('disabled', false);
    }
});
